import { apiUrlPrefix, devMode } from "~/shared/config"

/**
 * Префикс для api в режиме production
 */
export const apiUriPrefixProd = apiUrlPrefix || "https://api-next.kemsu.ru/api"

/**
 * Префикс для api в режиме development
 */
export const apiUriPrefixDev = apiUrlPrefix || "https://api-dev.kemsu.ru/api"

/** Префиск для api, значение которого зависит от текущего режима (development или production) */
export const curApiUriPrefix = devMode ? apiUriPrefixDev : apiUriPrefixProd
